module.exports = __webpack_public_path__ + "img/winerackdog15.733fb0fd.jpg";